import { useEffect, useState } from "react"
import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDInput from "components/MDInput"
import MDNumberInput from "../components/MDNumberInput"
import MDTypography from "components/MDTypography"
import SectionCard from "../components/SectionCard"
import {
  useGetGrnQuery,
  useSaveGrnMutation,
  useMarkGrnDeliveredMutation,
} from "shared/redux/endpoints/procurement"

const GrnTab = ({ requestId, readOnly }) => {
  const { data } = useGetGrnQuery(requestId, { skip: !requestId })
  const [saveGrn, { isLoading: saving }] = useSaveGrnMutation()
  const [markDelivered, { isLoading: marking }] = useMarkGrnDeliveredMutation()
  const [lines, setLines] = useState([])

  useEffect(() => {
    setLines(data || [])
  }, [data])

  const updateLine = (idx, patch) =>
    setLines((prev) =>
      prev.map((l, i) => (i === idx ? { ...l, ...patch } : l))
    )

  const handleSave = () => saveGrn({ id: requestId, lines })
  const handleMarkDelivered = () => markDelivered(requestId)

  if (!lines || lines.length === 0)
    return (
      <MDTypography variant="body2" color="text">
        No goods receipt lines yet.
      </MDTypography>
    )

  return (
    <SectionCard title="Goods Receipt" icon="inventory_2" mb={0}>
      {lines.map((l, idx) => (
        <MDBox key={idx} p={2} mb={1} bgColor="grey-100" borderRadius="lg">
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={4}>
              <MDInput
                fullWidth
                labelType="non-sticky"
                labelText="Item"
                value={l.itemName || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <MDNumberInput
                fullWidth
                labelType="non-sticky"
                labelText="Qty received"
                value={l.qtyReceived ?? 0}
                onChange={(v) => updateLine(idx, { qtyReceived: Number(v) })}
                disabled={readOnly}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <MDInput
                fullWidth
                type="date"
                labelType="non-sticky"
                labelText="Received date"
                value={l.receivedDate || ""}
                onChange={(e) => updateLine(idx, { receivedDate: e.target.value })}
                disabled={readOnly}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <MDInput
                fullWidth
                labelType="non-sticky"
                labelText="Note"
                value={l.note || ""}
                onChange={(e) => updateLine(idx, { note: e.target.value })}
                disabled={readOnly}
              />
            </Grid>
          </Grid>
        </MDBox>
      ))}
      {!readOnly && (
        <MDBox display="flex" gap={2} mt={2}>
          <MDButton
            variant="outlined"
            color="info"
            disabled={saving}
            onClick={handleSave}
          >
            Save GRN
          </MDButton>
          <MDButton
            variant="gradient"
            color="success"
            disabled={marking}
            onClick={handleMarkDelivered}
          >
            Mark Delivered
          </MDButton>
        </MDBox>
      )}
    </SectionCard>
  )
}

export default GrnTab
